import React, { useState } from "react";
import styles from "./SlidingTabs.module.css";

export interface TabItem {
    label: string;
    notification?: number;
}

interface SlidingTabsProps {
    tabs: TabItem[];
    defaultIndex?: number;
    onChange?: (index: number) => void;
    tabWidth?: number; // default 200
}

const SlidingTabs = ({
    tabs,
    defaultIndex = 0,
    onChange,
    tabWidth = 200,
}: SlidingTabsProps) => {
    const [activeIndex, setActiveIndex] = useState(defaultIndex);

    const handleChange = (index: number) => {
        setActiveIndex(index);
        if (onChange) onChange(index);
    };

    return (
        <div className={styles.container}>
            <div className={styles.tabs}>
                {tabs.map((tab: TabItem, index: number) => (
                    <React.Fragment key={index}>
                        <input
                            type="radio"
                            id={`radio-${index}`}
                            name="tabs"
                            checked={activeIndex === index}
                            onChange={() => handleChange(index)}
                        />
                        <label
                            htmlFor={`radio-${index}`}
                            className={styles.tab}
                            style={{ width: tabWidth }}
                        >
                            {tab.label}
                            {tab.notification !== undefined && (
                                <span className={styles.notification}>{tab.notification}</span>
                            )}
                        </label>
                    </React.Fragment>
                ))}
                <span
                    className={styles.glider}
                    style={{
                        width: tabWidth,
                        transform: `translateX(${activeIndex * 100}%)`,
                    }}
                />
            </div>
        </div>
    );
};

export default SlidingTabs;
